import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as biDetailsState from '../employee-detail.reducer';
import * as biDetailsReducer from '../reducers/bi-details.reducer';

export const getBusinessDetailsInfo = createSelector(biDetailsState.getBusinessInfoDetailsState, biDetailsReducer.getBusinessInfoDetails);
